<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="9">
            <h3 tabindex="0">Propostas da Delegação</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="8">
            <b-form-group label="Título do Caderno:">
              <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Título do Caderno"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group label="Período">
              <b-input-group>
                <b-form-input id="type-date" type="datetime-local" min="2000-01-01T00:00" max="2200-12-01T00:00"
                  v-model.lazy.trim="filtros.data_contribuicao_inicio"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <div style="margin-top: 3%;">a</div>
          <b-col cols="4" style="margin-top: 1.7rem;">
            <b-form-group label="">
              <b-input-group>
                <b-form-input id="type-date" type="datetime-local" min="2000-01-01T00:00" max="2200-12-01T00:00"
                  v-model.lazy.trim="filtros.data_contribuicao_fim"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <b-button block variant="primary" @click="pesquisar">
              <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <table selectable aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                class="table table-responsive-sm table-bordered table-striped table-sm">
                <thead>
                  <tr>              
                    <th scope="col" tabindex="0">Título Caderno de Proposta</th>
                    <th scope="col" tabindex="0">Período</th>
                    <th scope="col" tabindex="0">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="propostas.data !== undefined">
                  <tr class="action" v-for="proposta in propostas.data" :key="proposta.id">                 
                    <td tabindex="0">{{ proposta.titulo | sliceContent }}</td>
                    <td>
                        <span v-if="proposta.data_contribuicao_inicio && proposta.data_contribuicao_fim"> {{ moment(proposta.data_contribuicao_inicio).format('DD/MM/YYYY HH:mm') }} a {{ moment(proposta.data_contribuicao_fim).format('DD/MM/YYYY HH:mm') }}</span>
                    </td>
                    <td style="width: 15%">  
                      <b-button class="btn btn-sm btn-secondary action" title="Visualizar" tabindex="0"
                        @click="visualizarProposta(proposta.id)">
                        <i class="fa fa-search"></i>
                      </b-button>                  
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="5" tabindex="0">Nenhuma proposta</td>
                  </tr>
                </tbody>
              </table>
              <!-- <pagination tabindex="0" v-show="propostas.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination> -->
            </span>
          </b-container>
        </b-col>
      </b-row>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import { DatePicker, setupCalendar } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  filters: {
    sliceContent: function (string) {
      string = string.replace(/<\/?[^>]+>/ig, " ")
      if (string.length > 100) {
        return string.slice(0, 100) + '...'
      }
      return string
    },
  },
  created() {
    if (!this.validaPerfil()) {
      this.$router.push('/')
    }

    this.pesquisar()
  },
  data() {
    return {
      totalPorPagina: false,
      resource: 'propostaDelegacao',
      loading: false,
      filtros: {
        filter: null,
        permite_contribuicao: true,
        data_contribuicao_inicio: null,
        data_contribuicao_fim: null
      },
    }
  },
  computed: {
    propostas() {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    }
  },
  methods: {
    validaPerfil () {
       let perfil = this.$store.state.perfil.perfil     
       if (perfil.is_admin_conferencia || perfil.is_admin_local) {
         this.is_admin = true
         return true
       }
       return false
    },
    setarFiltros(filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar() {
      this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
      this.setarFiltros(this.filtros)
    },
    visualizarProposta(id) {
      this.$router.push('/propostas/delegacao/'+ id +'/visualizar' )
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>.multiselect.invalid .multiselect__tags,
.multiselect.invalid .multiselect__tags span,
.multiselect.invalid .multiselect__tags input {
  background: red;
}</style>



// WEBPACK FOOTER //
// src/pages/site/interna/propostaDelegacao/PropostaDelegacao.vue